// Single Activity model — module-scoped form definitions. Employees log activities; KPIs auto-calc.
const base = (role) => [
  { key: "employee_name", label: "Employee", type: "employee", role },
  { key: "date", label: "Date", type: "date" },
];
const tail = [
  { key: "proof_link", label: "Proof Link", type: "link" },
  { key: "remarks", label: "Remarks", type: "text" },
];

export const ACTIVITY_MODULES = {
  pr: {
    label: "PR", role: "PR Manager",
    columns: [...base("PR Manager"),
      { key: "activity_type", label: "Type", type: "select", options: ["Coverage", "Award", "Appearance"] },
      { key: "publication", label: "Publication", type: "text" },
      { key: "title", label: "Title", type: "text" },
      { key: "status", label: "Status", type: "select", options: ["Planned", "Submitted", "Published", "Rejected", "Won", "Shortlisted"] },
      { key: "reach", label: "Reach", type: "number" },
      ...tail],
  },
  social: {
    label: "Social Media", role: "Social Media Manager",
    columns: [...base("Social Media Manager"),
      { key: "platform", label: "Platform", type: "select", options: "$platforms" },
      { key: "post_type", label: "Post Type", type: "text" },
      { key: "topic", label: "Topic", type: "text" },
      { key: "status", label: "Status", type: "select", options: ["Planned", "Published"] },
      { key: "views", label: "Views", type: "number" },
      { key: "likes", label: "Likes", type: "number" },
      { key: "comments", label: "Comments", type: "number" },
      { key: "shares", label: "Shares", type: "number" },
      ...tail],
  },
  influencer: {
    label: "Influencer", role: "Influencer Manager",
    columns: [...base("Influencer Manager"),
      { key: "influencer", label: "Influencer", type: "text" },
      { key: "platform", label: "Platform", type: "text" },
      { key: "stage", label: "Stage", type: "select", options: ["Researched", "Reached", "Response", "Negotiating", "Onboarded", "Collaboration"] },
      { key: "cost", label: "Cost (₹)", type: "number" },
      { key: "reach", label: "Reach", type: "number" },
      { key: "engagement", label: "Engagement", type: "number" },
      { key: "leads", label: "Leads", type: "number" },
      { key: "revenue", label: "Revenue (₹)", type: "number" },
      ...tail],
  },
  video_production: {
    label: "Shoot", role: "Videographer",
    columns: [...base("Videographer"),
      { key: "shoot_type", label: "Shoot Type", type: "select", options: ["Treatment", "Batch Shoot", "Dr. Awish", "Patient Review", "Before-After", "Educational", "Promotional", "Reel", "Other"] },
      { key: "subject", label: "Subject", type: "text" },
      { key: "location", label: "Location", type: "text" },
      { key: "status", label: "Status", type: "select", options: ["Planned", "In Progress", "Completed"] },
      { key: "handed_to_editor", label: "Handed to Editor", type: "select", options: ["Y", "N"] },
      { key: "footage_ref", label: "Footage Ref", type: "text" },
      ...tail],
  },
  video_editing: {
    label: "Editing", role: "Video Editor",
    columns: [...base("Video Editor"),
      { key: "project", label: "Project", type: "text" },
      { key: "status", label: "Status", type: "select", options: ["Editing", "Review", "Completed", "Published"] },
      { key: "on_time", label: "On Time", type: "select", options: ["Y", "N"] },
      { key: "revisions", label: "Revisions", type: "number" },
      { key: "final_link", label: "Final Link", type: "link" },
      ...tail],
  },
  content_writing: {
    label: "Writing", role: "Content Writer",
    columns: [...base("Content Writer"),
      { key: "content_type", label: "Type", type: "select", options: "$content_types" },
      { key: "topic", label: "Topic", type: "text" },
      { key: "status", label: "Status", type: "select", options: ["Draft", "Review", "Approved", "Published"] },
      { key: "revisions", label: "Revisions", type: "number" },
      { key: "link", label: "Published Link", type: "link" },
      ...tail],
  },
  graphic_design: {
    label: "Design", role: "Graphic Designer",
    columns: [...base("Graphic Designer"),
      { key: "title", label: "Title", type: "text" },
      { key: "creative_for", label: "Creative For", type: "select", options: ["Treatment", "Courses", "Offer", "Meta Ads", "Branding", "PR", "Social Media", "Other"] },
      { key: "design_type", label: "Type", type: "select", options: "$design_types" },
      { key: "status", label: "Status", type: "select", options: ["Pending", "Review", "Completed", "Published"] },
      { key: "revisions", label: "Revisions", type: "number" },
      { key: "file_link", label: "File Link", type: "link" },
      ...tail],
  },
  seo: {
    label: "SEO", role: "SEO",
    columns: [...base("SEO"),
      { key: "activity_type", label: "Type", type: "select", options: ["Ranking", "Backlink", "Technical", "Content"] },
      { key: "page", label: "Page", type: "text" },
      { key: "keyword", label: "Keyword", type: "text" },
      { key: "status", label: "Status", type: "select", options: ["Open", "Resolved", "Done"] },
      { key: "leads", label: "Leads", type: "number" },
      { key: "traffic", label: "Traffic", type: "number" },
      ...tail],
  },
};
